/**
 * #Sorry
 */
import PropTypes from 'prop-types';
import GoFetch from '~/js/modules/fetchling';
import CustomColorPicker from '../CustomColorPicker';


const { Fragment } = React;

const internals = {
  regions: {
    jamaica: 10,
    turksandcaicos: 7
  },
  loaderHelper(show = true) {
    if (!show) {
      $('.loader').fadeOut(1200);
      document.querySelector('.loader').classList.remove('show-loader');
      $('body').removeClass('noscroll');

      return 0;
    }
    $('body').addClass('noscroll');
    document.querySelector('.loader').classList.add('show-loader');
    $('.loader').fadeIn(1200);

    return 0;
  }
};

export default class WishlistCollageEventItem extends React.Component {

  static propTypes = {
    itemDetail: PropTypes.object,
    regionId: PropTypes.number,
    regionName: PropTypes.string,
    wishlistId: PropTypes.number,
    wishlistUserId: PropTypes.number,
    wishlistRemoveItemHandler: PropTypes.func,
    wishlistCode: PropTypes.string,
    updateWishlistData: PropTypes.func,
    formatLastDateSaved: PropTypes.func,
    calculateWishlistTotal: PropTypes.func
  };

  constructor() {
    super();

    this.sizeRef = React.createRef();
    this.priceRef = React.createRef();
    this.quantityRef = React.createRef();
  }

  _removeItemButtonHandler = () => {

    const { wishlistUserId: userId, regionId, wishlistId: wishListId, wishlistCode: wishListCode } = this.props;
    const { event: eventName, categoryName, subCategoryName, attributeId, wishListItemId, quantity, price } = this.props.itemDetail;
    // declaring fetch request body
    const body = {
      userId,
      regionId,
      wishListId,
      wishListCode,
      csrfToken: window.beaches_app.page.csrfToken,
      items: [
        {
          attributeId,
          wishListItemId,
          quantity,
          price,
          delete: true
        }
      ]
    };

    internals.loaderHelper();
    $.ajax({
      url: '/wishlist/save/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(body)
    })
      // `/wishlist/save/` is used to remove, add and update items in a wishlist
      .done((result) => {
        // once the fetch promise resolves we need to update the parent component state and remove the loader animation
        const updatedWishlistSavedDate = result.data.saveWishListResult.find((el) => el.id === wishListId).lastUpdate;

        this.props.wishlistRemoveItemHandler(eventName, categoryName, subCategoryName, wishListItemId, updatedWishlistSavedDate);
        internals.loaderHelper(false);
      })
      .fail((textStatus, errorThrown) => console.warn(errorThrown));
  }

  _onChangeHandler = (e) => {
    const requestBody = {};
    const { itemDetail } = this.props;
    const isFormControl = e.hasOwnProperty('target');


    requestBody.wishListId = this.props.wishlistId;
    requestBody.userId = this.props.wishlistUserId;
    requestBody.regionId = this.props.regionId;
    requestBody.csrfToken = window.beaches_app.page.csrfToken;

    if (isFormControl) {
      const { wishListItemId, attributeId, price, quantity } = itemDetail;

      // https://reactjs.org/docs/events.html#event-pooling
      e.persist();

      // Why though
      switch (e.target.name) {
        case 'price':
          requestBody.regionId = internals.regions[e.target.value.toLowerCase()];

          requestBody.items = [
            {
              wishListItemId,
              attributeId,
              quantity,
              price
            }
          ];
          break;
        case 'quantity':
          const updatedQuantity = (e.target.value.length) ? parseInt(this.quantityRef.current.value, 10) : 0;

          requestBody.items = [
            {
              wishListItemId,
              attributeId,
              quantity: updatedQuantity,
              price
            }
          ];
          break;
        case 'size':

          requestBody.items = [
            {
              wishListItemId,
              attributeId: e.target.value,
              quantity,
              price
            }
          ];
          break;
        default:
          // statements_def
          break;
      }

    } else {
      const { wishListItemId, quantity, price } = itemDetail;
      const attributeId = itemDetail.colorList.find((el) => el.color.toLowerCase() === e.toLowerCase()).id;

      requestBody.items = [
        {
          wishListItemId,
          attributeId,
          quantity,
          price
        }
      ];
    }

    this._updateItemRequest(requestBody, e);
  }

  _updateItemRequest = _globalUtils.debounce((requestBody, event) => {

    if (requestBody.items[0].quantity === 0) {
      return 0;
    }

    if (event.hasOwnProperty('target')) {
      event.target.disabled = true;
    }

    const { updateWishlistData } = this.props;

    internals.loaderHelper();

    $.ajax({
      url: '/wishlist/save/',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestBody)
    })
      .done((result) => {
        if (result.status === 'success') {
          this._fetchWishlistInformation()
            .then( async(updatedWishlistResp) => {
              const { wishListItems, wishListDetails: { itemCount, lastUpdate, regionId }, regionName } = updatedWishlistResp.data.wishListItems;
              const { date: { day, month, year }, time: { hour, minute } } = lastUpdate;
              const formattedLastSavedDate = this.props.formatLastDateSaved(month, day, year, hour, minute);
              const wishlistTotal = this.props.calculateWishlistTotal(wishListItems);
              const region = { id: regionId, name: regionName.replace(/[\s-]+/g, '') };

              await updateWishlistData(wishListItems, itemCount, wishlistTotal, formattedLastSavedDate, true, region);
              await internals.loaderHelper(false);
            });
        }
        if (event.hasOwnProperty('target')) {
          event.target.disabled = false;
        }
      })
      .fail((textStatus, errorThrown) => console.warn(errorThrown));

    return 0;
  }, 500)

  _fetchWishlistInformation = () => {
    const fetchWishlistRequest = new GoFetch();
    const { wishlistId: wishListId } = this.props;
    const requestBody = { wishListId };

    return fetchWishlistRequest.post('/wishlist/items/', null, requestBody);
  }

  _capPhrase = (phrase) => phrase.replace(/_/g, ' ').replace(/\b[a-z](?=[a-z]{2})/g, letter => letter.toUpperCase());

  _renderItemDetails = (itemData) => {
    const sizeDefault = itemData.sizeList.find((el) => el.size === itemData.size);
    const isNotAllRegion = (itemData.price > 0 && itemData.priceList.length > 0 && itemData.priceList[0].region && itemData.priceList[0].region !== 'ALL REGIONS');
    const priceOptions = (isNotAllRegion) ? itemData.priceList.map((el, i) => (<option key={`${el.region || "item"}-${i}`} value={el.region ? el.region.replace(/[\s-]+/g, '') : "item"}>{`${this._capPhrase(el.region ? el.region.toLowerCase(): "item") } $${el.price}`}</option>)) : null;

    return(
      <Fragment>
        {
          (itemData.size.length > 0) && <div className="xs-10 xxl-3">
            <div className="row middle-xs center-xxl">
              <label htmlFor="size" className="item-attribute name font-bold xs-4 xxl-12">SIZE:</label>
              {
                itemData.sizeList.length > 0
                  ? (<div className="control-wrapper custom-ddl xs-8 xxl-12">
                    <select name="size" id="size" defaultValue={sizeDefault.id || itemData.size} ref={this.sizeRef} onChange={ this._onChangeHandler }>
                      {
                        itemData.sizeList.map((el, i) => (<option key={`${el.id}-${i}`} value={el.id}>{this._capPhrase(el.size.toLowerCase())}</option>))
                      }
                    </select>
                  </div>)
                  : (<label className="xs-8 xxl-12">{itemData.size}</label>)
              }
            </div>
          </div>
        }
        {
          itemData.color.toUpperCase() !== 'DEFAULT' && <div className="xs-10 xxl-3">
            <div className="color-picker-wrapper">
              <CustomColorPicker
                currentItemColor={ itemData.color }
                layoutSize="row middle-xs xs-0"
                colorLabelSize="xs-4 xxl-12 item-attribute name font-bold"
                ddlTextWrapperSize="xs-8 xxl-12"
                itemColors={ itemData.colorList }
                editItemCallback={ this._onChangeHandler }
              />
            </div>
          </div>
        }
        <div className="xs-10 xxl-1">
          <div className="row middle-xs center-xxl">
            <label htmlFor="quantity" className="item-attribute name font-bold xs-4 xxl-12">quantity:</label>
            <div className="control-wrapper xs-8 xxl-12">
              <input id="quantity" name="quantity" type="number" min={1} maxLength={4} defaultValue={itemData.quantity} ref={this.quantityRef} onChange={ this._onChangeHandler } />
            </div>
          </div>
        </div>
        <div className="xs-10 xxl-3">
          <div className="row middle-xs center-xxl">
            {
              (itemData.price > 0) && <label htmlFor="price" className="item-attribute name font-bold xs-4 xxl-12">price per unit:</label>
            }
            {
              isNotAllRegion && <div className="control-wrapper custom-ddl xs-8 xxl-12">
                <select name="price" id="price" value={ this.props.regionName } ref={this.priceRef} onChange={ this._onChangeHandler } >
                  {priceOptions}
                </select>
              </div>
            }
            {
              !isNotAllRegion && <span className="xs-8 xxl-12 single-price">{`$${itemData.price}`}</span>
            }
          </div>
        </div>
      </Fragment>
    );
  }

  render() {
    const { itemDetail, regionName } = this.props;
    const fallbackImg = '/v12/images/wedding-styler/no-img.jpg';
    const itemNotAvailable = (!itemDetail.hasOwnProperty('price') || itemDetail.price === '');
    const totalPrice = (itemDetail.hiddenPrice) ?
      (<span className="call-for-pricing-copy xs-12"><strong>CALL FOR PRICING</strong> 1-877-SANDALS</span>) :
      (<Fragment>
        <span className="item-total-amount xs-4 xxl-12 font-bold">total price:</span>
        <span className="item-total-value xs-8 xxl-12">{(itemDetail.price === 0) ? ' FREE' : ` $${itemDetail.totalPrice}`}</span>
      </Fragment>);

    return (
      <div className="card-white wishlist-item-card pr">
        <div className="row">
          <div className="hidden-large-down lg-4 xxl-3 no-pad-right-left">
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src={`//cdn.sandals.com/sandals${ (itemDetail.imagePath.length) ? itemDetail.imagePath : fallbackImg }`} className="lazyload img-responsive use-attributes" alt=""/>
          </div>
          <div className="xs-12 lg-8 xxl-9 wishlist-item-details-wrapper">
            <div className="row start-xs">
              <div className="xs-3 hidden-large-up">
                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src={`//cdn.sandals.com/sandals${ (itemDetail.imagePath.length) ? itemDetail.imagePath : fallbackImg }`} className="lazyload img-responsive use-attributes" alt=""/>
              </div>
              <div className="xs-9 lg-12 item-title pr">
                <button className="remove-item-btn font-bold" onClick={ this._removeItemButtonHandler }>REMOVE</button>
                <span className="item-subcategory-name">{itemDetail.subCategoryName}</span>
                <h6 className="wishlist-item-name font-normal">
                  {itemDetail.name}
                  <small className="item-inspiration display-block">
                    {`${itemDetail.inspirationName} Inspiration`}
                  </small>
                </h6>
              </div>
              <div className="xs-11 wishlist-item-details">
                <div className="row center-xs middle-xs top-xxl end-xxl">
                  <div className="xs-12">
                    <hr className="semi-transparent-grey-dvdr"/>
                  </div>
                  {
                    itemNotAvailable && <span className="not-available-msg xs-12">{`ITEM NOT AVAILABLE IN ${regionName}`}</span>
                  }
                  {
                    !itemNotAvailable && this._renderItemDetails(itemDetail)
                  }
                  <div className="xs-12 hidden-xxl-up">
                    <hr className="semi-transparent-grey-dvdr"/>
                  </div>
                  <div className="xs-10 xxl-2 pr add-vertical-dvdr">
                    <div className="row middle-xs">
                      {
                        !itemNotAvailable && totalPrice
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
